import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService } from '../config';
import { CustomHttp } from '../http';
import { Cep } from './cep';

@Injectable({
    providedIn: 'root'
})
export class CepService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cep`;
    }


    /** Realiza a consulta do CEP informado */
    consultar(codigoCep: string): Observable<Cep> {
        if (!codigoCep) {
            codigoCep = '1'; // CEP inválido simplesmente para realizar a requisição
        }

        return this.customHttp.get<Cep>(`${this.pathApi}/${codigoCep}`);
    }
}
